import moment from "moment";
import React, { useMemo } from "react";
import { BabyPage } from "../../interfaces";

interface Props {
  babypage: BabyPage;
}

const BabyPageOrderable: React.FC<Props> = ({ babypage }) => {
  const title = useMemo(() => {
    let bp_title: string = babypage.title;
    if (babypage.title === "") bp_title = "BabyPage";
    if (babypage.event === "Custom Page" && babypage.title === "")
      bp_title = "Custom Page";
    return (
      <>
        <h1 className="title">{bp_title}</h1>
      </>
    );
  }, [babypage]);

  return (
    <div className="col-6 col-sm-4 col-md-4 col-lg-3 babypage-item-preview">
      <img src={babypage.thumbnail} alt={babypage.title} className="w-100" />
      <div className="babypage-content">
        {title}
        <p className="subtitle">
          {moment(babypage.original_title).format("MMMM Do, YYYY")}
        </p>
      </div>
    </div>
  );
};
export default BabyPageOrderable;
